import React from "react";
import RateStyles from "../styles/RateStyles";
import TopPhotoBannerStyles from "../styles/TopPhotoBannerStyles";
import { StaticImage } from "gatsby-plugin-image";
import Seo from "../seo";

const Rate = () => {
  return (
    <>
      <Seo
        title="Rate"
        description="Inspire businesses to do better by rating restaurants in a new, holistic way."
        url="https://www.table-sage.com/rate"
        image="https://res.cloudinary.com/table-sage/image/upload/f_auto,q_auto:good/v1616506314/top-banners/rate-banner_ttorrv.jpg"
        imageWidth="500"
        imageHeight="375"
      />
      <TopPhotoBannerStyles
        style={{
          display: "grid",
        }}
      >
        <StaticImage
          style={{
            gridArea: "1/1",
            maxHeight: 500,
            minHeight: 500,
          }}
          layout="fullWidth"
          quality={80}
          // This is a presentational image, so the alt should be an empty string
          alt=""
          src={
            "https://res.cloudinary.com/table-sage/image/upload/f_auto,q_auto:good/v1616506314/top-banners/rate-banner_ttorrv.jpg"
          }
          loading="eager"
          placeholder="blurred"
        />
        <div
          style={{
            // By using the same grid area for both, they are stacked on top of each other
            gridArea: "1/1",
            position: "relative",
            background:
              "linear-gradient(rgba(35, 31, 32, 0.25), rgba(35, 31, 32, 0.25))",
          }}
        >
          <h1 className="header">Make feedback matter</h1>
          <h2 className="sub-header">
            Inspire businesses to do better by rating restaurants in a new,
            holistic way.
          </h2>
          {/* <div className="center-button mt-4">
            <Link to="/contact" className="photo-banner-btn">
              Join the waitlist
            </Link>
          </div> */}
        </div>
      </TopPhotoBannerStyles>
      <RateStyles>
        <p className="top-msg">
          We're building the first, bigger-picture restaurant rating platform.
        </p>
        <div className="evaluate__first-section-container">
          <div className="evaluate__first-section">
            <div className="iframe-container">
              <iframe
                src="https://player.vimeo.com/video/370645410"
                className="evaluate__video"
                frameBorder="0"
                allow="autoplay; fullscreen"
                title="Why Table Sage? Exploring the need for a new restaurant rating system that includes food sustainability and diversity in the restaurant industry"
              ></iframe>
            </div>
            <div className="evaluate__block-1">
              <h2 className="evaluate__header-2">Comprehensive</h2>
              <p className="evaluate__body-copy">
                A five-point rating system that looks at what’s best for you,
                your community, and the planet.
              </p>
            </div>
            <div className="evaluate__block-2">
              <h2 className="evaluate__header-2">Circular</h2>
              <p className="evaluate__body-copy">
                Reviews are submitted by transparent experts as well as
                validated diners. Your feedback will be consolidated, analyzed,
                and sent to eateries for consideration.
              </p>
              <div className="evaluate__screenshots">
                <StaticImage
                  alt="Mobile screen showing Amsterdam restaurant review page on new Table Sage rating platform"
                  src="https://res.cloudinary.com/table-sage/image/upload/v1594287153/rate-homepage/screens_rating01_vnt6aw.png"
                  placeholder="blurred"
                  layout="fixed"
                  width={282}
                  height={600}
                  quality={100}
                  imgClassName="evaluate__screenshots-item"
                  className="evaluate__screenshots-item"
                />
                <StaticImage
                  alt="Mobile phone screen of holistic five-step rating process on upcoming rating platform by Table Sage"
                  src="https://res.cloudinary.com/table-sage/image/upload/v1594287153/rate-homepage/screens_rating02_1_pz5k32.png"
                  placeholder="blurred"
                  layout="fixed"
                  width={282}
                  height={600}
                  quality={100}
                  imgClassName="evaluate__screenshots-item"
                  className="evaluate__screenshots-item"
                />
                <StaticImage
                  alt="Smart phone screen showing user's trustworthy restaurant rating on proposed sustainable Table Sage Rate platform"
                  src="https://res.cloudinary.com/table-sage/image/upload/v1594287153/rate-homepage/screens_rating03_mfktfe.png"
                  placeholder="blurred"
                  layout="fixed"
                  width={282}
                  height={600}
                  quality={100}
                  imgClassName="evaluate__screenshots-item"
                  className="evaluate__screenshots-item"
                />
                {/* <Image
                className="evaluate__screenshots-item"
                cloudName="table-sage"
                publicId="rate-homepage/screens_rating01_vnt6aw.png"
                alt="Mobile screen showing Amsterdam restaurant review page on new Table Sage rating platform"
              ></Image>
              <Image
                className="evaluate__screenshots-item"
                cloudName="table-sage"
                publicId="rate-homepage/screens_rating02_1_pz5k32.png"
                alt="Mobile phone screen of holistic five-step rating process on upcoming rating platform by Table Sage"
              ></Image>
              <Image
                className="evaluate__screenshots-item"
                cloudName="table-sage"
                publicId="rate-homepage/screens_rating03_mfktfe.png"
                alt="Smart phone screen showing user's trustworthy restaurant rating on proposed sustainable Table Sage Rate platform"
              ></Image> */}
              </div>
            </div>
            <div className="evaluate__block-3">
              <h2 className="evaluate__header-2">Complete</h2>
              <p className="evaluate__body-copy">
                For every review, we make a $1 donation towards initiatives that
                fight hunger.
              </p>
            </div>{" "}
          </div>
        </div>
        <div className="evaluate__block-4 mb-8">
          <p className="evaluate__body-copy-2">
            Find a city of interest. Filter your preferences. Eat, review,
            repeat.
          </p>
        </div>
      </RateStyles>
    </>
  );
};

export default Rate;
